import React from 'react';

import { noop } from 'lodash';

import BaseDialog from './BaseDialog';

import Button from '~/core/atoms/Buttons/Button';

export interface ErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  onConfirm?: () => void;
  confirmText?: string;
  showCancel?: boolean;
  cancelText?: string;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
  isOpen = false,
  onClose = noop,
  title = 'Error',
  message,
  onConfirm = noop,
  confirmText = 'OK',
  showCancel = false,
  cancelText = 'Cancel',
}) => {
  const actions = (
    <div className="flex items-center justify-end gap-12">
      {showCancel && (
        <Button className="text-grey-500 border-grey-300 box-border border-1" outline={true} onClick={onClose}>
          {cancelText}
        </Button>
      )}
      <Button
        className="bg-red-700 hover:bg-red-800"
        onClick={async () => {
          try {
            await onConfirm();
          } catch (error) {
            console.error('Error during confirmation:', error);
          }
          await onClose();
        }}
      >
        {confirmText}
      </Button>
    </div>
  );

  return (
    <BaseDialog isOpen={isOpen} onClose={onClose} title={title} actions={actions}>
      <p className="text-grey-700 text-sm">{message}</p>
    </BaseDialog>
  );
};

export default ErrorDialog;
